var PRIMEDefaultCohort3 = {
  "name": "EDIC intensive",
  "note": "",
  "version": 1,
  "project": null,
  "references": "Nathan et al. Diabetes control and complications trial/epidemiology of diabetes interventions and complications study at 30 years: advances and contributions. Diabetes. 2013;62(12):3976-86.",
  "male": {
  "proportion": 51.3
},
  "smokers": {
  "proportion": 11.5
},
  "takingAntiHypertensiveMedication": {
  "proportion": 60.3
},
  "takingAntiThromboticMedication": {
  "proportion": 0
},
  "takingPrimaryLipidModifyingMedication": {
  "proportion": 0
},
  "takingSecondaryLipidModifyingMedication": {
  "proportion": 0
},
  "age": {
  "mean": 52.3,
    "sd": 6.9
},
  "durationOfDiabetesAtBaseline": {
  "mean": 30.7,
    "sd": 5
},
  "hbA1c": {
  "mean": 8,
    "sd": 1
},
  "sbp": {
  "mean": 122.4,
    "sd": 15.4
},
  "totalCholesterolMmolL": {
  "mean": 4.52033,
    "sd": 0.91544
},
  "ldlmmolL": {
  "mean": 2.50066,
    "sd": 0.75511
},
  "hdlmmolL": {
  "mean": 1.60073,
    "sd": 0.50168
},
  "bmi": {
  "mean": 29.1,
    "sd": 5.7
},
  "neuropathyAtBaseline": {
  "proportion": 23.6
},
  "cardioVascularDiseaseAtBaseline": {
  "proportion": 0
},
  "macularEdemaAtBaseline": {
  "proportion": 0
},
  "cHFAtBaseline": {
  "proportion": 0
},
  "amputationAtBaseline": {
  "proportion": 0
},
  "retinopathyAtBaseline": {
  "stateProportionMap": {
    "NO": 47.5,
      "MILD_NPDR": 21.3,
      "MODERATE_NPDR": 16.5,
      "SEVERE_NPDR": 14.7,
      "PDR": 0,
      "SVL": 0
  }
},
  "renalStateDistributionAtBaseline": {
  "stateProportionMap": {
    "NORMAL": 81.5,
      "MICROALBUMINURIA": 14.2,
      "OVERT": 4.3,
      "ESRD": 0
  }
},
  "creationDate": 1529095239298,
  "creator": "default"
}
